import {pub, sub} from './pubsub.js'
import tab from './tab.js'

function resize(innerWidth, innerHeight) {
    // xtermjs 的 xterm-screen 元素在它的外层容器窗口高度增加时可以自动增加， 但其外层容器窗口高度减少时并不会自动减少
    // 这里需要在广播窗口变化之前手动设置 xterm-screen 元素高度，以便广播之后 xtermjs 的窗口可以调用 fit 来自适应窗口高度
    // workspace height 为窗口高度减去 tabs header 高度和 bottom tips bar 高度
    setClassElementSize("xterm-screen", innerWidth + "px", (innerHeight - 26 - 30) + "px")
    pub("winResize", {width: innerWidth, height: innerHeight})

    // 通知当前 tab 的内部模块重新调整大小，例如 terminal
    pub('resize-' + tab.curTabKey)
}

function setClassElementSize(className, width, height) {
    let els = document.getElementsByClassName(className)
    if (els && els.length > 0) {
        for (let el of els) {
            el.style.width = width
            el.style.height = height
        }
    }
}

function resizeAddCallback(cb) {
    sub("winResize", cb)
}

export default {
    resize,
    resizeAddCallback,
}